import { jsx, jsxs } from 'react/jsx-runtime';
import { useQueryResourceAssets } from '../../../../queries/useQueryResourceAssets.js';
import { styled } from 'styled-components';
import { useResourceEmailDataContextSafe } from '../../../context/resourceDataContext.js';
import { useShowExpandedResource } from '../../../../../resources/stores/useExpandedResourceStore.js';
import { isNumber } from '@fabric-app/utils/guards';
import { mediaHover, cssTextEllipsis } from '@fabric-app/ui/constants/styled-utils';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { Flex } from '@fabric-app/ui/components/Flex';
import { P, SPAN } from '@fabric-app/ui/components/Typography';
import { formatFileSize } from '@fabric-app/utils/number';
import { getResourceKindIcon } from '../../../../../resources/constants/resourceIcons.js';
import { Kind } from '@fabric/woody-client';

const ResourceEmailAttachments = () => {
  const { resource } = useResourceEmailDataContextSafe();
  const { data } = useQueryResourceAssets({
    resource
  });
  const resources = data?.data.assets;
  if (!resources) {
    return null;
  }
  return /* @__PURE__ */ jsx(Flex, {
    direction: "column",
    gap: "element",
    children: resources.map((resource2) => /* @__PURE__ */ jsx(Attachment, {
      resource: resource2
    }, resource2.id))
  });
};
const Attachment = ({ resource }) => {
  const showExpandedResource = useShowExpandedResource();
  const handleOpen = () => {
    showExpandedResource(resource, {
      storeCurrentAsPrevious: true,
      disableSwitcher: true
    });
  };
  const Icon = getResourceKindIcon(resource.kind);
  return /* @__PURE__ */ jsxs(Container, {
    children: [
      /* @__PURE__ */ jsx("a", {
        style: {
          position: "absolute",
          inset: 0,
          zIndex: 0,
          cursor: "pointer"
        },
        onClick: handleOpen
      }),
      /* @__PURE__ */ jsx(IconContainer, {
        children: /* @__PURE__ */ jsx(Icon, {})
      }),
      /* @__PURE__ */ jsxs(TextContainer, {
        children: [
          /* @__PURE__ */ jsxs(Flex, {
            overflow: "hidden",
            alignItems: "center",
            children: [
              /* @__PURE__ */ jsx(Title, {
                color: "primary",
                children: resource.name
              }),
              resource.extension && /* @__PURE__ */ jsxs(SPAN, {
                size: "lg",
                color: "tertiary",
                weight: 500,
                children: [
                  ".",
                  resource.extension
                ]
              })
            ]
          }),
          isNumber(resource.size) && resource.kind !== Kind.NOTEPAD && /* @__PURE__ */ jsx(AdditionalTextInfo, {
            children: formatFileSize(resource.size)
          })
        ]
      })
    ]
  });
};
const Container = styled(Flex).attrs(() => {
  return {
    alignItems: "center"
  };
}).withConfig({
  displayName: "ResourceEmailAttachments__Container",
  componentId: "sc-a25018cc-0"
})([
  `margin-left:0.1rem;margin-right:0.1rem;position:relative;gap:10px;padding-left:0.375rem;height:1.875rem;padding-right:0.4375rem;text-transform:none;font-weight:500;text-decoration:none !important;border-radius:6px;width:max-content;max-width:100%;background:`,
  `;`,
  `{&:hover{background:`,
  `;}}`
], cssVar["color-bg-secondary"], mediaHover, cssVar["color-bg-section"]);
const IconContainer = styled(Flex).attrs({
  alignItems: "center",
  justifyContent: "center"
}).withConfig({
  displayName: "ResourceEmailAttachments__IconContainer",
  componentId: "sc-a25018cc-1"
})([
  `height:1rem;width:1rem;color:`,
  `;`
], cssVar["color-text-primary"]);
const TextContainer = styled(Flex).attrs({
  alignItems: "baseline",
  justifyContent: "center"
}).withConfig({
  displayName: "ResourceEmailAttachments__TextContainer",
  componentId: "sc-a25018cc-2"
})([
  ``,
  `;gap:6px;`
], cssTextEllipsis);
const AdditionalTextInfo = styled(P).attrs((props) => {
  return {
    color: "placeholder",
    size: "xxs",
    weight: 500,
    ...props
  };
}).withConfig({
  displayName: "ResourceEmailAttachments__AdditionalTextInfo",
  componentId: "sc-a25018cc-3"
})([
  `display:flex;align-items:center;gap:4px;`
]);
const Title = styled(P).attrs({
  size: "lg",
  weight: 500
}).withConfig({
  displayName: "ResourceEmailAttachments__Title",
  componentId: "sc-a25018cc-4"
})([
  ``,
  `;`
], cssTextEllipsis);

export { Attachment, ResourceEmailAttachments };
//# sourceMappingURL=ResourceEmailAttachments.js.map
